// extracted by mini-css-extract-plugin
export var wordContainer = "_m4-0";